import { GridSize } from '@material-ui/core'

export interface IPoll {
  header: string
  id: string
  qrImg?: string
  qrText?: string
  options: Array<{ label: string; results?: number }>
}

interface ISubItems {
  preHeader?: string
  logo?: string
  header?: string
  video?: string
  image?: string
  imgFallback?: string
  body?: string
  inlineBody1?: string
  inlineBody2?: string
  links?: IDemoLinkConfig[]
  gWidth?: GridSize
}

export interface IDemoLinkConfig {
  text?: string
  icon?: string
  goTo?: string
  colSize?: any
  param?: string
}

export interface ITimestamp {
  logo?: string
  header?: string
  body?: string
  items?: Array<ISubItems>
  list?: Array<string>
}

export enum ETouchpoints {
  None = 'none',
  RobotFrontArms = 'robotFrontArms',
  RobotMiddle = 'robotMiddle',
  RobotScannerBox = 'robotScannerBox'
}

export interface ITouchpoints {
  [key: string]: ISubItems[]
}

export interface IDemo {
  id?: string
  autoplay?: boolean
  conversationId?: string
  intro?: string
  video?: string
  poster?: string
  monolith?: string
  type?: string
  end?: {
    header: string
    body: string
    nextDemo?: string | IDemo
    nextDemoId?: string
    nextDemoText?: string
    nextDemoThumbnail?: string
    previousDemoId?: string
    expert?: string
    qr?: string
    links?: IDemoLinkConfig[]
  }
  touchpoints?: ITouchpoints
  timestamps?: { [key: number]: Array<ITimestamp> }
  poll?: IPoll
}

export interface IDemoCollection {
  [key: string]: IDemo
}

export enum DemoIds {
  mecExplainer = 'mec-explainer',
  iceMobility = 'ice-mobility',
  jigspace = 'jigspace',
  osirix = 'osirix',
  transformationOfHealthcare = 'transformation-of-healthcare',
  speedOfThought = 'speed-of-thought',
  mecAndSmartVenues = 'mec-and-smart-venues',
  transformingTheFanExperience = 'transforming-the-fan-experience',
  shotTracker = 'shot-tracker',
  indy = 'indy-500'
}

export enum SessionIds {
  aerialApplications = 'aerial-applications',
  blueforce = 'blueforce',
  taqtile = 'taqtile',
  vuzix = 'vuzix'
}

export enum E3DDemoNameVals {
  unknown = '0',
  justGotReal = '1',
  jigspace = '2',
  ibmMaximo = '3',
  osirix = '4',
  fiveStatesOfReady = '5',
  mecExplainer = '6',
  sot = '7',
  transformingTheFanExperience = '8',
  shotTracker = '9',
  mecAndSmartVenues = '10',
  zixi = '11',
  fiveGCoverage = '2000',
  tata = '100',
  avesha = '101',
  iceMobility = '102',
  indy = '101'
}

export enum E3DSessionNameVals {
  unknown = '0',
  drones = '1',
  iot = '2',
  taqtile = '3',
  vuzix = '4'
}

export interface IEventReplay {
  [key: string]: IReplayItem
}
export interface IReplayItem {
  id: string
  title: string
  subtitle: string
  next: string
  poster: string
  thumbnail: string
  videoSrc: string
}
